import type {StoreFrontMessage} from '../types/storeFrontMessage';

export const en: StoreFrontMessage = {
  productPage: {
    customiseButton: 'Customise',
  },
};
